import React, {useEffect, useRef} from 'react';
import styled from 'styled-components';
import {D} from '../ai-chat/design-tokens';

const DropdownContainer = styled.div`
	position: absolute;
	background: ${D.bg};
	border: 1px solid ${D.v2.borderEnabled};
	border-radius: 8px;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
	padding: 8px 0;
	z-index: 10;
`;

type AgentDropdownProps = {
	onClose: () => void;
	excludeRef?: React.RefObject<HTMLElement>;
	style?: React.CSSProperties;
	children: React.ReactNode;
};

const AgentDropdown = ({onClose, excludeRef, style, children}: AgentDropdownProps): JSX.Element => {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const onKeyDown = (e: KeyboardEvent) => {
			if (e.key === 'Escape') {
				e.stopPropagation();
				onClose();
			}
		};
		const onMouseDown = (e: MouseEvent) => {
			if (excludeRef?.current?.contains(e.target as Node)) return;
			if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
				onClose();
			}
		};

		document.addEventListener('keydown', onKeyDown);
		document.addEventListener('mousedown', onMouseDown);
		return () => {
			document.removeEventListener('keydown', onKeyDown);
			document.removeEventListener('mousedown', onMouseDown);
		};
	}, [onClose, excludeRef]);

	return (
		<DropdownContainer ref={containerRef} style={style}>
			{children}
		</DropdownContainer>
	);
};

export default AgentDropdown;
